import { type MouseEvent, forwardRef } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const MailIcon = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <rect x="1.75" y="2.75" width="12.5" height="10.5" rx="1.25" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M7.30662 7.63636L1.75176 3.93312C1.78652 3.27386 2.33208 2.75 3 2.75H13C13.6679 2.75 14.2135 3.27386 14.2482 3.93312L8.69337 7.63636C8.2735 7.91628 7.7265 7.91628 7.30662 7.63636Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
));
